import secureLocalStorage from "react-secure-storage";
import { TextArea } from "@progress/kendo-react-inputs";
import * as React from "react";

export default class TaskAlertDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      temp:this.props.dataItem[this.props.field]
    };
  }
  componentDidMount = () => {
    if(this.props.dataItem.inEdit&&document.getElementById("taskalertstackeholder")){
        document.getElementById("taskalertstackeholder").focus();
    }
  };
  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  handleBlur = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit 
    ) {
      let updateData = {
        ...this.props.dataItem,
        [this.props.field]: this.state.temp,
      };
      this.props.updateDropdownValue(updateData);
    }
  };
  handleEditCell = () => {
    if(this.props.dataItem.isClosed===false || this.props.dataItem.isClosed==="Open"){

    this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
 const ownerId=dataItem.ownerId;
 const dataValue =
      dataItem[field] === null || dataItem[field] === undefined
        ? ""
        : dataItem[field];
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td 
        className="k-grid-content-sticky-temp  inlineEditField"
         >
          <TextArea
            defaultValue={dataValue}
            onChange={(e) => this.handleChange(e)}
            onBlur={this.handleBlur}
            id="taskalertstackeholder"
          />
        </td>
      );
    } else {
      if((loginUserId===ownerId)&&this.props.dataItem.isClosed===false){
        return (
          <td title={dataValue} onClick={this.handleEditCell}>
          {dataValue}
        </td>
        )
      }else{
        return  this.props.dataItem.roleName === "View Only" ||
          this.props.dataItem.roleName === "Standard User" ||
          this.props.dataItem.isClosed===true ? (
          <td title={dataValue}>{dataValue}</td>
        ) : (
          <td title={dataValue} onClick={this.handleEditCell}>
            {dataValue}
          </td>
        )
      }
    }
  }
}
